import { render } from "./ConfiguracaoRanks.vue?vue&type=template&id=e88b87ce&scoped=true"
import script from "./ConfiguracaoRanks.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoRanks.vue?vue&type=script&lang=js"

import "./ConfiguracaoRanks.vue?vue&type=style&index=0&id=e88b87ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88b87ce"]])

export default __exports__